
export default {
    state:{
        usuario:false,
        usuariopermisos:[],
        accessToken:'',
        autenticado:false,
        token:false
    },
    mutations:{
        setAutenticacion(state,data){
            state.usuario = data.usuario
            state.usuariopermisos = data.usuario.usuariopermiso
            state.accessToken = data.accessToken
            state.autenticado=true;
        },
        updateAuth(state,estado){
            state.autenticado = estado
        },
        setTokenUser(state,token){
            state.token = token
        }
    },
    actions:{
        postAutenticacion({commit},usuario){
            commit('setAutenticacion',usuario)
        },
        updateAuth({commit},estado){
            commit('updateAuth',estado)
        },
        setTokenUser({commit},token){
            commit('setTokenUser',token)
        }
    },
    getters:{
        usuarioAuth(state){
            return {usuario:state.usuario,autenticado:state.autenticado}
        },
        usuarioPermisos(state){
            return state.usuariopermisos
        },
        getAutenticado(state){
            return state.autenticado;
        },
        getTokenUser(state){
            if(!state.token){
                return {headers:{'Authorization':'Bearer '+JSON.parse(sessionStorage.getItem('token')) }}
            }else{

                return {headers:{'Authorization':'Bearer '+state.token}};
            }

            
        }
    }
}